import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initLenis, scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/shikra/Nav";
import { Hero } from "@/components/shikra/Hero";
import { AudienceToggle } from "@/components/shikra/AudienceToggle";
import { Decisions } from "@/components/shikra/Decisions";
import { Technology } from "@/components/shikra/Technology";
import { Team } from "@/components/shikra/Team";
import { Marquee } from "@/components/shikra/Marquee";
import { Contact } from "@/components/shikra/Contact";
import ForUtilities from "@/pages/ForUtilities";
import ForCI from "@/pages/ForCI";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = ({ audience, setAudience, techOpen, setTechOpen }) => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 500);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div className="bg-[#F5F4F0] text-[#121413] min-h-screen">
      <Nav onSelectAudience={setAudience} onOpenTechnology={() => setTechOpen(true)} />
      <main>
        <Hero />
        <AudienceToggle audience={audience} setAudience={setAudience} />
        <Decisions />
        <Technology open={techOpen} setOpen={setTechOpen} />
        <Team />
        <Marquee />
        <Contact onSelectAudience={setAudience} onOpenTechnology={() => setTechOpen(true)} />
      </main>
    </div>
  );
};

function App() {
  const [audience, setAudience] = useState("ci");
  const [techOpen, setTechOpen] = useState(false);

  useEffect(() => {
    initLenis();
  }, []);

  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              audience={audience}
              setAudience={setAudience}
              techOpen={techOpen}
              setTechOpen={setTechOpen}
            />
          }
        />
        <Route path="/for-utilities" element={<ForUtilities />} />
        <Route path="/for-commercial-industrial" element={<ForCI />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
